<div class="my-automations">
  <div class="my-automations__alert">
    <img src="/assets/icons/dca/question.svg" alt="question" />
    <p>
      ¿Qué es DCA? Es una estrategia que consiste en invertir una misma cantidad de dinero cada
      cierto tiempo (días, semanas, meses). Busca reducir el impacto de la volatilidad y maximizar
      tus rendimientos.
    </p>
  </div>
  <div class="my-automations__title">
    <h3>Mis automatizaciones</h3>
    <button
      *ngIf="(data | async)?.rules?.length > 0 && !isMobile"
      class="my-automations__create-button"
      [routerLink]="'create'"
    >
      <img src="/assets/icons/plus_rules.svg" alt="plus" />
      Crear regla
    </button>
  </div>
  <app-empty-state
    [isMobile]="isMobile"
    *ngIf="(data | async)?.rules?.length === 0"
  ></app-empty-state>
  <div class="my-automations__rules" *ngIf="(data | async)?.rules?.length > 0">
    <div class="my-automations__rules__header">
      <div class="my-automations__rules__header-change">
        <div>
          <p>Monedas</p>
        </div>
      </div>
      <div class="my-automations__rules__header-amount">
        <p>Monto a operar</p>
      </div>
      <div class="my-automations__rules__header-frequency">
        <p>Frecuencia</p>
      </div>
      <div class="my-automations__rules__header-next" *ngIf="!isMobile">
        <p>Próxima compra</p>
      </div>
      <div class="my-automations__rules__header-state" *ngIf="!isMobile">
        <p>Estado</p>
      </div>
    </div>
    <div class="my-automations__rules__cards">
      <ng-container *ngFor="let rule of (data | async)?.rules">
        <app-rule-card
          [rule]="rule"
          [isMobile]="isMobile"
          (updateRules)="updateRules($event)"
        ></app-rule-card>
      </ng-container>
    </div>
  </div>
  <div class="my-automations__btn-mobile-create" *ngIf="isMobile">
    <div>
      <button class="my-automations__create-button" [routerLink]="'create'">
        <img src="/assets/icons/plus_rules.svg" alt="plus" />
        Crear regla
      </button>
    </div>
  </div>
</div>
